<template lang="pug">
tbody
  tr(data-test-id="scheduled-deal-row")
    td {{ bookingDeal.dealName }}
    td
    td
    td
      DealQuantityPicker(:bookingDeal="innerBookingDeal")
    td
    td
      TrashIconButton(@delete="$emit('deleteDeal', bookingDeal.dealKey)")
  BookingProductsTableRow(
    v-for="bookingProduct in innerBookingDeal.scheduledProducts"
    :key="bookingProduct.Key"
    :bookingProduct="bookingProduct"
    :products="products"
    :resources="resources"
    :bookingProductIsSplit="bookingProductIsSplit(bookingProduct)"
    :bookingDeal="innerBookingDeal"
    )
</template>

<script>
import TrashIconButton from '@v/bookings/edit/components/TrashIconButton.vue'
import BookingProductsTableRow from './BookingProductsTableRow.vue'
import DealQuantityPicker from '@v/bookings/edit/components/DealQuantityPicker.vue'
import { bookingProductIsSplit } from '@v/bookings/edit/util/bookingDealFunctions.js'

export default {
  name: 'BookingDealTableSection',
  components: { TrashIconButton, BookingProductsTableRow, DealQuantityPicker },
  props: {
    bookingDeal: { type: Object, required: true },
    products: { type: Array, required: true },
    resources: { type: Object, required: true },
    classifications: Array,
  },
  data() {
    return {
      innerBookingDeal: this.bookingDeal,
    }
  },
  methods: {
    bookingProductIsSplit(bookingProduct) {
      return bookingProductIsSplit(this.bookingDeal, bookingProduct.ProductGroupProductKey)
    },
  },
}
</script>
